import { Component, Prop, Vue } from 'vue-property-decorator'
import store from '@/store'
@Component({
  components: {}
})
export default class Layout extends Vue {
  organizationName: string = store.state.charge?.actuateName || ''
  userName: string = store.state.fullname
}